import type { Routine } from "./routine.types";

const STORAGE_KEY = "saradium-routines";

export function loadRoutines(): Routine[] {
  try {
    const value = JSON.parse(
      localStorage.getItem(STORAGE_KEY) || "[]",
    );

    return Array.isArray(value)
      ? (value as Routine[])
      : [];
  } catch {
    return [];
  }
}

export function saveRoutines(
  routines: Routine[],
): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(routines),
  );
}